import {
    SUB_CATEGORIES_FETCH_SUCCESS,
    SUB_CATEGORIES_FETCH_RESET
} from "../actions/types";


const INIT_STATE = {
    subCategories: []
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SUB_CATEGORIES_FETCH_SUCCESS: {
            return {
                ...state,
                subCategories: action.payload
            };
        }
        case SUB_CATEGORIES_FETCH_RESET: {
            return {
                ...state,
                subCategories: []
            }
        }
        default:
            return state;
    }
};